import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils.ts";

export type MedicalTeamNote = {
  // id: string
  content: string | undefined;
  // updatedAt: string
};

export const medicalTeamNoteSchema = cz.camelCaseObject({
  // id: z.string(),
  content: z.string(),
  // updated_at: cz.datetime(),
});
